module.exports = __webpack_public_path__ + "static/media/Office_Amenities_mob.2a5995ee.jpg";